import Container from '../../Basic/Container/Container.mjs';
import styled from 'styled-components';

const StyledContainer = styled(Container) `
  position: relative;
  width: 100%;
  margin: 0 auto;
`;
const containerHeight = '700px';
const HeroBackground = styled.div `
  width: 100%;
  margin: 0 auto;
  height: ${containerHeight};
  box-sizing: border-box;
  position: absolute;
  z-index: ${props => props.theme.zIndex.negative};
  background-image: url('${props => props.bgImage}');
  background-size: cover;
  background-repeat: no-repeat;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: ${containerHeight};
    background: ${props => props.theme.gradients.platformsOverlay};
    z-index: ${props => props.theme.zIndex.negative};
  }
`;

export { HeroBackground, StyledContainer };
//# sourceMappingURL=HeroBackgroundContainer.styles.mjs.map
